<div 
	class="error-msg" 
	*ngIf="(error$ | push : strategy) === true" 
	[@ifHeightAnimation]
>
	<p>Pro textové vyhledávání zadejte alespoň 3 znaky.</p>
</div>

<div class="fulltext-wrapper"  >
	<input 
		#input
		class="fulltext-input" 
		placeholder="Hledat"  
		value="{{(pageParams$ | push).fullText}}" 
		(blur)="onBlur($event)"
		(focus)="onFocus($event)"
		(input)="onInput($event)"
		(keyup.enter)="submit($event)"
	/>
	<button 
		class="submit-button button-hidden" 
		type="submit" 
		title="hledat {{input.value}}"
		matRipple
		(click)="onSubmit(input.value)"
	>
	  <app-icon class="filter-icon" name="search"></app-icon>
	</button>
	<div 
		class="cancel-button circle-line" 
		*ngIf="(showReset$ | push : strategy) === true" 
		[@fadeIfAnimation] 
		(click)="resetText($event)" 
		matRipple
	>
		<app-icon name="close"></app-icon>
	</div>
</div>